/**
 * DevExtreme (esm/__internal/scheduler/r1/components/base/row.js)
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import { createVNode, createComponentVNode } from "inferno";
import { BaseInfernoComponent, normalizeStyles } from "../../../../core/r1/runtime/inferno/index";
import { splitNumber } from "../../utils/index";
import { VirtualCell, VirtualCellDefaultProps } from "./virtual_cell";
const MAX_COL_SPAN = 1e3;
export const RowDefaultProps = {
  className: "",
  leftVirtualCellWidth: 0,
  rightVirtualCellWidth: 0,
  isHeaderRow: false
};
export let Row = /*#__PURE__*/(() => {
  class Row extends BaseInfernoComponent {
    render() {
      const {
        children: children,
        className: className,
        isHeaderRow: isHeaderRow,
        leftVirtualCellCount: leftVirtualCellCount,
        leftVirtualCellWidth = RowDefaultProps.leftVirtualCellWidth,
        rightVirtualCellCount: rightVirtualCellCount,
        rightVirtualCellWidth = RowDefaultProps.rightVirtualCellWidth,
        styles: styles
      } = this.props;
      const hasLeftVirtualCell = Boolean(leftVirtualCellCount);
      const hasRightVirtualCell = Boolean(rightVirtualCellCount);
      return createVNode(1, "tr", className, [hasLeftVirtualCell && null != leftVirtualCellCount && splitNumber(leftVirtualCellCount, 1e3).map(colSpan => createComponentVNode(2, VirtualCell, {
        width: leftVirtualCellWidth * (colSpan / leftVirtualCellCount),
        colSpan: colSpan,
        isHeaderCell: isHeaderRow ?? VirtualCellDefaultProps.isHeaderCell
      })), children, hasRightVirtualCell && null != rightVirtualCellCount && splitNumber(rightVirtualCellCount, 1e3).map(colSpan => createComponentVNode(2, VirtualCell, {
        width: rightVirtualCellWidth * (colSpan / rightVirtualCellCount),
        colSpan: colSpan,
        isHeaderCell: isHeaderRow ?? VirtualCellDefaultProps.isHeaderCell
      }))], 0, {
        style: normalizeStyles(styles)
      });
    }
  }
  Row.defaultProps = RowDefaultProps;
  return Row;
})();